/* eslint-disable react/prop-types */
import classNames from 'classnames';
import React from 'react';

import Styles from './index.less';

const MAX_SECTION_NAME_LENGTH = 255;

interface ISectionTitleInputProps {
    isEditingName: boolean;
    name: string;
    onInputBlur: () => void;
    setName: (name: string) => void;
}

const SectionTitleInput: React.FC<ISectionTitleInputProps> = (props) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const [currentName, setCurrentName] = React.useState(props.name);

    React.useEffect(() => {
        if (props.isEditingName) {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [props.isEditingName]);

    const inputStyle = classNames({
        [Styles['slide-list-section-title-input']]: true,
        [Styles['input-editing']]: props.isEditingName,
        [Styles['input-readonly']]: !props.isEditingName,
    });

    const onInputKeydown: React.KeyboardEventHandler<HTMLInputElement> = (event) => {
        if (event.key === 'Enter' && currentName !== props.name) {
            props.setName(currentName);
        }
        if (event.key === 'Enter' || event.key === 'Escape') {
            props.onInputBlur();
            // 编辑完节标题之后，焦点可能在左侧幻灯片列表里
            // 需要做失焦来确保 window 正常接收事件
            (document.activeElement as HTMLElement)?.blur?.();
        }
    };

    return (
        <input
            readOnly={!props.isEditingName}
            className={inputStyle}
            ref={inputRef}
            value={currentName}
            onChange={event => setCurrentName(event.target.value)}
            maxLength={MAX_SECTION_NAME_LENGTH}
            onBlur={() => {
                props.onInputBlur();
                if (currentName !== props.name) {
                    props.setName(currentName);
                }
                inputRef.current?.blur();
            }}
            onKeyDown={onInputKeydown}
        />
    );
};


export default SectionTitleInput;
